'use client';

import { Button, IcCopy, Typography } from '@musinsa/mds';
import { Tooltip } from '@musinsa/mds-ui';
import { useEffect, useState } from 'react';
import { isTooltipShown, markTooltipShown } from '../../common/utils';

interface OwnerSecondaryButtonProps {
  status: 'AVAILABLE' | 'RECEIVED' | 'EXHAUSTED' | 'EXPIRED';
  disabled?: boolean;
  onCopyLink?: () => void;
}

const FIRST_VISIT_TOOLTIP_STORAGE_KEY = 'tooltip-curator-coupon-goods-share-link';
const FIRST_VISIT_TOOLTIP_DURATION_MS = 5000;

export const OwnerSecondaryButton = ({
  status,
  disabled = false,
  onCopyLink,
}: OwnerSecondaryButtonProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (status === 'EXPIRED') return;
    if (isTooltipShown(FIRST_VISIT_TOOLTIP_STORAGE_KEY)) return;
    setShowTooltip(true);
  }, [status]);

  if (status === 'EXPIRED') return null;

  return (
    <div className="relative w-full">
      <Button
        variant="primary"
        className="w-full"
        size={32}
        disabled={disabled}
        onClick={onCopyLink}
      >
        <IcCopy width={16} height={16} strokeColor="white" />
        <Typography variant="body13pxMed" colorScheme="white" className="ml-0.5">
          공유 링크 복사
        </Typography>
      </Button>
      {showTooltip && (
        <div className="absolute top-full left-1/2">
          <Tooltip
            className="absolute! top-0! left-1/2! mt-[8px]! z-50! -translate-x-1/2! whitespace-nowrap!"
            align="bottom center"
            duration={FIRST_VISIT_TOOLTIP_DURATION_MS}
            onCloseCallback={() => {
              markTooltipShown(FIRST_VISIT_TOOLTIP_STORAGE_KEY);
              setShowTooltip(false);
            }}
            content={
              <>
                쿠폰 적용 상품 바로가기 링크를
                <br />
                복사할 수 있습니다.
              </>
            }
          />
        </div>
      )}
    </div>
  );
};
